export default {
      id: "plus-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#plus",
      toString: function () {
        return this.url;
      }
    }